import { Injectable } from '@angular/core';
import { ViajeDTO } from "../../dtos/viaje.dto";
import { BehaviorSubject, Observable } from "rxjs";
import { GeneralResponseDTO } from "../../dtos/response/general.response.dto";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class ViajeService {

  private viajeSeleccionado: ViajeDTO;
  private viajeSeleccionadoDespachador: ViajeDTO;

  private viajeSeleccionadoDespachadorSubject = new BehaviorSubject<ViajeDTO | null>(null);
  viajeSeleccionadoDespachador$ = this.viajeSeleccionadoDespachadorSubject.asObservable();

  constructor(private apiService: ApiService) {}

  getViajeSeleccionado() {
    return this.viajeSeleccionado;
  }

  getViajeSeleccionadoDespachador(): ViajeDTO{
    return this.viajeSeleccionadoDespachador;
  }
  
  public setViajeSeleccionadoDespachador(viaje: ViajeDTO): void {
    this.viajeSeleccionadoDespachadorSubject.next(viaje);
  }

  setViajeSeleccionado(viaje: ViajeDTO) {
    this.viajeSeleccionado = viaje;
  }

  iniciarViaje(viajeUuid: string, combustiblePorcentaje: number): Observable<GeneralResponseDTO> {
    return this.apiService.iniciarViaje(viajeUuid, combustiblePorcentaje);
  }

  confirmarConductorMovil(viajeUuid: string, conductorUuid: string, movilUuid: string): Observable<GeneralResponseDTO> {
    return this.apiService.confirmarConductorMovil(viajeUuid, conductorUuid, movilUuid);
  }
}
